<template>
  <svg baseProfile="full"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:ev="http://www.w3.org/2001/xml-events"
    class="chart ph1">

    <!-- debugger
    <rect x="0" y="0" width="100%" height="10" fill='silver'/>
    -->

    <rect v-if="settings.style.showBase" x="0" y="2" width="100%" height="2" fill="#EEEEEE" />
    <circle v-if="settings.style.roundBorders" cx="0" cy="3" r="1" fill="#EEEEEE"/>
    <circle v-if="settings.style.roundBorders" cx="100%" cy="3" r="1" fill="#EEEEEE"/>

    <circle v-if="settings.style.roundBorders" cx="0" cy="3" r="3" :fill="settings.style.color"/>
    <circle v-if="settings.style.roundBorders" :cx="`${progressLengthPercent}%`" cy="3" r="3" :fill="settings.style.color"/>
    <rect x="0" y="0" :width="`${progressLengthPercent}%`" height="6" :fill="settings.style.color"/>

  </svg>
</template>

<script>
import { colors } from '@/plugins/colors.js'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  created () {
    this.$lo.merge(this.settings, this.data)
  },
  data () {
    return {
      // переданный в prop config мержится с settings
      settings: {
        series: {
          value: 0,
          total: 0
        },
        style: {
          color: colors[0],
          showBase: true, // показывать ли серенькую полоску на всю длинну прогресса
          roundBorders: true // закругленные края прогресса
        }
      }
    }
  },
  computed: {
    progressLengthPercent () {
      const total = this.settings.series.total >= this.settings.series.value
        ? this.settings.series.total
        : this.settings.series.value
      return this.settings.series.value / total * 100
    }
  }
}
</script>

<style lang="scss" scoped>
.chart {
  overflow: visible;
  width: 100%;
  height: 6px;
}
</style>
